import * as types from "../actions/actionTypes";
import createEntityReducer from "./createEntityReducer";

export default createEntityReducer({
  entity: "orderestimate",
  listKey: "estimates",
  itemKey: "estimate",
  getAll: types.GET_ALL_ORDER_ESTIMATES,
  getAllResponse: types.GET_ALL_ORDER_ESTIMATES_RESPONSE,
  getByIdResponse: types.GET_ORDER_ESTIMATE_BY_ID_RESPONSE,
});
